module.exports = __webpack_public_path__ + "static/media/logo1.aead831b.jpg";